import { createSlice } from "@reduxjs/toolkit";
import {
  addNewCustomers,
  getAllCustomers,
  getCustomerDetailById,
} from "../thunks/addCustomerThunk";

const initialState = {
  isCustomerLoading: false,
  customers: [],
  counts: {
    all: 0,
    active: 0,
    inactive: 0,
    bill_due: 0,
  },
  pagination: {
    current_page: 1,
    total_pages: 1,
    total_records: 0,
  },
};

const addCustomerSlice = createSlice({
  name: "addCustomers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addNewCustomers.pending, (state) => {
        state.isCustomerLoading = true;
      })
      .addCase(addNewCustomers.fulfilled, (state, action) => {
        ((state.isCustomerLoading = false), (state.action = action.payload));
      })
      .addCase(addNewCustomers.rejected, (state) => {
        state.isCustomerLoading = false;
      })
      .addCase(getAllCustomers.pending, (state) => {
        state.isCustomerLoading = true;
      })
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        state.isCustomerLoading = false;
        const data = action.payload.data;
        state.customers = data.customers || [];
        state.counts = data.counts || {};
        state.pagination.current_page = data.current_page;
        state.pagination.total_pages = data.total_pages;
        state.pagination.total_records = data.total_records;
      })

      .addCase(getAllCustomers.rejected, (state) => {
        state.isCustomerLoading = false;
      })

      .addCase(getCustomerDetailById.pending, (state) => {
        state.isCustomerLoading = true;
      })
      .addCase(getCustomerDetailById.fulfilled, (state, action) => {
        ((state.isCustomerLoading = false), (state.action = action.payload));
      })
      .addCase(getCustomerDetailById.rejected, (state) => {
        state.isCustomerLoading = false;
      });
  },
});

export default addCustomerSlice.reducer;
